import "./SimpleModal.scss";
import { useTranslation } from "react-i18next";
export default function SimpleModal({
  isOpen,
  size,
  overlay,
  actionPosition,
  children,
  title,
  onClose,
  submitButtonTitle,
  submitButtonAction,
  cancelButtonAction,
  cancelButtonTitle,
  customFooter
}) {
  let { t } = useTranslation();
  function footerPosition() {
    if (actionPosition === "left") {
      return (
        <div className="simple-modal-actions-left">
          <button className="btn btn-second " onClick={cancelButtonAction}>
            {cancelButtonTitle}
          </button>
          <button className="btn btn-prime " onClick={submitButtonAction}>
            {submitButtonTitle}
          </button>
        </div>
      );
    } else if (actionPosition === "spaceBetween") {
      return (
        <div className="row">
          <div className="simple-modal-actions-left   col  p-0">
            <button className="btn btn-second " onClick={cancelButtonAction}>
              {cancelButtonTitle}
            </button>
          </div>
          <div className="simple-modal-actions-right col  p-0">
            <button className=" btn btn-prime " onClick={submitButtonAction}>
              {submitButtonTitle}
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="simple-modal-actions-right col">
          <button className="btn btn-second m-1" onClick={cancelButtonAction}>
            {cancelButtonTitle || t("Cancel")}
          </button>
          <button className="btn btn-prime m-1" onClick={submitButtonAction}>
            {submitButtonTitle || t("Submit")}
          </button>
        </div>
      );
    }
  }
  return (
    <div className={`${overlay && isOpen ? "simple-modal-overlay" : ""}`}>
      <div
        className={`simple-modal  ${
          isOpen ? "simple-modal-show" : ""
        } simple-modal${size ? "-" + size : "-md"} `}
      >
        <div className="simple-modal-header  row">
          <div className="simple-modal-title col">
            <h4>{title}</h4>
          </div>
          <div className="simple-modal-close col-1 text-end" onClick={onClose}>
            <span>X</span>
          </div>
        </div>

        <div className="simple-modal-body  ">{children}</div>
        <div className="simple-modal-footer ">
          {(customFooter && customFooter()) || footerPosition()}
        </div>
      </div>
    </div>
  );
}
